import React from 'react'
import { Button, Form, FormGroup, Input, InputGroup, Label, InputGroupAddon, Nav, NavItem, NavLink } from 'reactstrap'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'
import '../../stylesheets/odometer-theme-default.css'
import ExtendIcon from 'react-icons/lib/fa/expand'
import SetPlanIcon from 'react-icons/lib/fa/cog'
import { subscriptionHelpers } from '../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, authRedirect, getCurrentTeam } from '../../dataHelpers/authenticationHelpers'
import classnames from 'classnames'
import '../../stylesheets/ControllerDashboard.css'
import AppError from "../../models/AppError"
import { getControllers } from "../../api"
import { ErrorModal } from './../ui'
import { SUCCESS, NO_DISCOUNT_LABEL, ENTER_DISCOUNT_LABEL, NO_DISCOUNT, ENTER_DISCOUNT_VAL, VALID_DISCOUNT_VAL, SUCCESS_DISCOUNT_LABEL_CREATE } from '../../constants'

class AddDiscountLabel extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: '1',
            errors: [],
            currentControllerPage: 1,
            loading: false,
            discountVal: '',
            discountLabel: '',
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.submitForm = this.submitForm.bind(this)
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { discountLabel, discountVal } = this.state

        if (!discountLabel || discountLabel == '') {
            let appError = new AppError(NO_DISCOUNT_LABEL, ENTER_DISCOUNT_LABEL)
            await this.setState({ errors: [appError], loading: false })
            return
        }

        if (!discountVal || discountVal == '') {
            let appError = new AppError(NO_DISCOUNT, ENTER_DISCOUNT_VAL)
            await this.setState({ errors: [appError], loading: false })
            return
        }
        if (!discountVal.match(/^\d+(\.\d+)?$/)) {
            let appError = new AppError(NO_DISCOUNT, VALID_DISCOUNT_VAL)
            await this.setState({ errors: [appError], loading: false })
            return
        }

        let discountLabelResponse = await subscriptionHelpers.createDiscountLabel(this.token, discountLabel, discountVal)
        if (!discountLabelResponse.error) {
            let appError = new AppError(SUCCESS, SUCCESS_DISCOUNT_LABEL_CREATE)
            await this.setState({ errors: [appError], loading: false, discountLabel: '', discountVal: '' })
            return
        } else {
            this.setState({ errors: [discountLabelResponse.error] })
        }
    }

    render() {
        let { loading, errors, discountLabel, discountVal } = this.state

        return (
            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Create Discount Level</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-6 col-md-8 col-sm-10">
                        <FormGroup>
                            <br />
                            <div>
                                <div className="text-left">
                                    <Label>Discount Level Name</Label>
                                    <InputGroup>
                                        <Input type="discountLabel"
                                            placeholder={`Discount Level Name`}
                                            value={discountLabel}
                                            onChange={(evt) => this.setState({ discountLabel: evt.target.value })}
                                            maxLength={20}
                                        />
                                    </InputGroup>
                                </div>
                                <br />
                                <div className="text-left">
                                    <Label>Discount Value (%)</Label>
                                    <InputGroup>
                                        <Input type="discountval"
                                            placeholder={`0`}
                                            value={discountVal}
                                            onChange={(evt) => this.setState({ discountVal: evt.target.value })}
                                            maxLength={5}
                                        />
                                        <InputGroupAddon addonType="append">%</InputGroupAddon>
                                    </InputGroup>
                                </div>
                            </div>
                        </FormGroup>
                        <Button className="mt-3">Create Discount</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>)
    }
}
export default AddDiscountLabel



// WEBPACK FOOTER //
// ./src/components/ui/AddDiscountLabel.js